import { SubscriptionDetailComponent } from './subscription-detail/subscription-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path:'subscription',
    component:SubscriptionDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionDetailRoutingModule { }
